<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Mandats en attente d'un accusé de réception"
      subtitle="Recherche de mandats"
      autocomplete_idHistory="warrants"
      autocomplete_field="creancier.nom_soc || mandat.ID"
      bdTable="mandat_acks"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      @row-clicked="selectRow"
      @loaded="refreshRoute"
    >
      <template v-slot:menu>
        <b-row class="mb-3">
          <b-col lg="12">
            <template v-if="$refs.resource">
              <b-button
                @click="sendAcks()"
                v-if="$refs.resource.pagination.ack && $refs.resource.pagination.ack.n_acks > 0"
                variant="info"
                class="mr-2"
                >Envoyer {{ $refs.resource.pagination.ack.n_acks }} accusés pour
                {{ $refs.resource.pagination.ack.n_warrants }} mandats
              </b-button>
              <b-modal
                id="send-acks"
                size="lg"
                @ok="confirm_send_acks"
                cancel-title="Annuler"
                ok-title="Envoyer"
              >
                <template #modal-title
                  >Envoyer les accusés de récpetion</template
                >
                <b-table
                  :items="$refs.resource.pagination.ack.creditors"
                  responsive
                  striped
                  hover
                ></b-table>
                <div v-if="sending_mails">
                  <b-icon icon="arrow-clockwise" animation="spin"></b-icon>
                  <span class="ml-3">Envoi des accusés de réception</span>
                </div>
              </b-modal>
            </template>

            <b-button
              v-if="$store.getters.isAdmin"
              variant="secondary"
              :to="{ name: 'addWarrantsPayments' }"
              class="mr-2"
              size="sm"
              icon
              title="Réceptionner des paiements"
              ><b-icon-credit-card-fill></b-icon-credit-card-fill
            ></b-button>
            <b-button-group class="mr-2">
              <b-button
                @click="createRoute"
                v-if="$store.getters.getRoute.length !== 0"
                variant="info"
                size="sm"
                title="Créer un itinéraire"
              >
                <b-icon v-if="!computeRoute" icon="geo-alt-fill"></b-icon>
                <b-icon v-else icon="arrow-clockwise" animation="spin"></b-icon>
                ({{ $store.getters.getRoute.length }})
              </b-button>
              <b-button
                size="sm"
                @click="deleteRoute"
                v-if="$store.getters.getRoute.length > 0"
                variant="danger"
              >
                <b-icon icon="x"></b-icon>
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </template>
      <template v-slot:cell(ID)="data">
        <b-link :to="{ name: 'warrantView', params: { id: data.item.ID } }">
          {{ data.item.ID }}
        </b-link>
      </template>
      <template v-slot:cell(realCreancier_nom_soc)="data">
        <b-link
          :to="{ name: 'creditorView', params: { id: data.item.creancierID } }"
        >
          {{ data.item.realCreancier_nom_soc }}
        </b-link>
      </template>
      <template v-slot:cell(arrangementID)="data">
        <span
          v-if="
            data.item.arrangementIsLate == 'Yes' &&
            data.item.status == 'ouvert' &&
            data.item.arrangementID != 0
          "
        >
          <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
        </span>
        <span
          v-else-if="
            data.item.status == 'ouvert' && data.item.arrangementID != 0
          "
        >
          <b-icon-check-circle-fill
            variant="success"
          ></b-icon-check-circle-fill>
        </span>
        <b-link
          v-if="data.item.arrangementID != 0"
          :to="{ name: 'settlement', params: { id: data.item.arrangementID } }"
        >
          {{ data.item.arrangementID }}
        </b-link>
        <span v-else>N/A</span>
      </template>
    </bd-table-list>
    <b-modal size="xl" id="google-route" hide-footer>
      <template #modal-title>Tournée négociateur</template>
      <GoogleRoute :data="googleData"></GoogleRoute>
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import GoogleRoute from "@/components/GoogleRoute";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageAcks",
  components: {
    BdTableList,
    GoogleRoute
  },
  data() {
    return {
      Api: gestion.ack,
      urlGoogleMaps: null,
      googleData: {},
      computeRoute: false,
      sending_mails: false,
      selectedWarrants: [],

      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats en attente d'accusé de réception",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          to: "warrantEdit",
        },
      ],
      fields: [
       {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },
        {
          key: "status",
          label: "Statut",
          sortable: true,
          thStyle: { width: "100px" },
        },

        {
          key: "realCreancier_nom_soc",
          label: "Créancier",
          sortable: true,
          class: "text-truncate",
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
          class: "text-truncate",
          formatter: (value, key, item) => {
            let a = "";
            if (item.nom_soc) {
              a += item.nom_soc;
            }
            if (item.nom && item.nom_soc) {
              a += " (" + item.prenom + " " + item.nom + ")";
            } else if (!item.nom_soc) {
              a += item.prenom + " " + item.nom;
            }
            return a;
          },
        },
        {
          key: "adresse",
          label: "Adresse",
          class: "text-truncate",
          sortable: true,
          formatter: (value, key, item) => {
            let a = item.rue1 + ", " + item.codepostal + " " + item.localite;
            if (item.pays) {
              a += " (" + item.pays + ")";
            }

            return a;
          },
        },
        {
          key: "lastNegoDate",
          label: "Dernière négociation",
          class: "text-center",
          thStyle: { width: "5%" },
          sortable: true,
          formatter: (value) => this.toDate(value),
        },
        {
          key: "priorite",
          label: "Priorité",
          thStyle: { width: "5%" },
          class: "text-center",
          sortable: true,
        },
        {
          key: "arrangementID",
          label: "Arr.",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "negotiateurID",
          label: "Négo",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: { width: "100px"},
        },
      ],
    };
  },
  methods: {
    deleteRoute() {
      this.$store.commit("deleteRoute");
      this.urlGoogleMaps = "";
      this.refreshRoute();
    },
    sendAcks() {
      this.$bvModal.show("send-acks");
    },
    confirm_send_acks() {
      this.sending_mails = true;
      warrants.send_acks().then((response) => {
        this.sending_mails = false;
        this.$bvModal.hide("send-acks");
        if (response.data.success) {
          this.$bvToast.toast("Accusés de réception envoyés", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
        } else {
          this.$bvToast.toast("Erreur survenue : " + response.data.errors.join('\n'), {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "error",
            autoHideDelay: 2000,
            solid: false,
          });
        }
        this.$refs.resource.submitSearch(true);
      });
    },
    refreshRoute() {
      let routes = this.$store.getters.getRoute;
      this.$refs.resource.rows.forEach((el, index) => {
        if (routes.includes(el.ID)) {
          this.$refs.resource.rows[index]._rowVariant = "success";
        } else {
          this.$refs.resource.rows[index]._rowVariant = null;
        }
      });
    },
    selectRow(row) {
      //this.warrants[index]._rowVariant = 'success';
      this.urlGoogleMaps = null;
      const id = row.ID;
      this.$store.commit("toggleRoute", id);
      this.refreshRoute();

      //this.selectedWarrants = payload;
    },

    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    createRoute() {
      this.computeRoute = true;
      this.urlGoogleMaps = null;
      warrants
        .routes({
          nego: this.$store.getters.getKeycloak.me.ID,
          ids: this.$store.getters.getRoute,
        })
        .then((response) => {
          this.computeRoute = false;
          if (response.statusText == "OK" && response.data.url) {
            this.urlGoogleMaps = response.data.url;
            this.googleData = response.data;
            this.$bvModal.show("google-route");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>